import React from 'react';
export function Footer() {
  return <footer className="bg-[#F8FAFC] border-t border-gray-200 py-12 px-8 mt-auto" data-id="element-175">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-176">
        <div className="flex-shrink-0" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/5icnLANuoMbRioXHmJAYNk/Paysys_Logo.png" alt="Paysys Logo" className="h-8 opacity-80 grayscale hover:grayscale-0 transition-all" data-id="element-178" />
        </div>

        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-medium text-gray-600" data-id="element-179">
          <a href="#" className="hover:text-[#0B5FA5] transition-colors" data-id="element-180">
            Documentation
          </a>
          <a href="#" className="hover:text-[#0B5FA5] transition-colors" data-id="element-181">
            API Reference
          </a>
          <a href="#" className="hover:text-[#0B5FA5] transition-colors" data-id="element-182">
            Support
          </a>
          <a href="#" className="hover:text-[#0B5FA5] transition-colors" data-id="element-183">
            Contact
          </a>
        </nav>

        <div className="text-sm text-gray-500 font-medium" data-id="element-184">
          Powered by <span className="text-gray-900 font-bold" data-id="element-185">Paysys</span>
        </div>
      </div>
    </footer>;
}